import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Observable, of } from 'rxjs';
import { debounceTime, map, distinctUntilChanged, tap, switchMap, catchError, startWith, finalize } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { HomeService } from 'src/app/modules/home/services/home.service';
import { Router } from '@angular/router';
import { ROUTES_URL } from '@app/core';
// import { NgbTypeahead, NgbModal } from '@ng-bootstrap/ng-bootstrap';
// import { ISubmitSearch } from '@app/modules/home/pages/interfaces/submit-search.interface';
// import { IBusquedaAutoComplete } from '@app/modules/home/pages/interfaces/busqueda-autocomplete.interface';


@Component({
  selector: 'app-section-home-buscador',
  templateUrl: './section-home-buscador.component.html',
  styleUrls: ['./section-home-buscador.component.scss']
})
export class SectionHomeBuscadorComponent implements OnInit {

  searchControl = new FormControl();
  filteredStates: any[];
  tipoControl = new FormControl();
  loading: boolean = false;
  tipoBusqueda: number = 1;

  constructor(
    private homeService: HomeService,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.subscribeToSearch();
  }

  subscribeToSearch = () => {

    const obs = value => this.tipoBusqueda == 1 ?
      this.homeService.buscarUniversidades({
        page: 1,
        pageSize: 100
      }, { term: value })
      : this.homeService.buscarProgramas({
        page: 1,
        pageSize: 100
      }, { term: value });

    this.searchControl.valueChanges
      .pipe(
        debounceTime(500),
        tap(() => {
          this.filteredStates = [];
          this.loading = true;
        }),
        switchMap(value => (
          typeof value === 'string' ? obs(value) : of({ data: [] })
        ).pipe(finalize(() => {
          this.loading = false
        })))
      ).subscribe(response => {
        this.filteredStates = response.data;
      });
  }

  handleClickSelect = (item) => {
    if (this.tipoBusqueda == 1) {
      const { value: entidad } = item.option;
      this.router.navigate([ROUTES_URL.UNIVERSIDADES.DETALLE(entidad.idEntidad)]);
    }

    if (this.tipoBusqueda == 2) {
      const { value: programa } = item.option;
      if (programa.total > 1) {
        this.router.navigate([ROUTES_URL.PROGRAMAS.BUSQUEDA], { queryParams: { term: programa.nombreProgama } });
      }
      else {
        this.router.navigate([ROUTES_URL.PROGRAMAS.DETALLE(programa.idPrograma, programa.idEntidad)]);
      }
    }

  }

  displayFn = item => {
    if (!item) {
      return null;
    }

    if (this.tipoBusqueda == 1) {
      return `${item.nombre} (${item.siglas})`;
    }

    if (this.tipoBusqueda == 2) {
      return `${item.nombreProgama}`;
    }
  }

  handleChangeTipoBusqueda = () => {
    this.filteredStates = [];
  }

}
